/**
 * Auth Context Definition
 * Defines the authentication context and related types
 */
import { createContext } from 'react';
// Create context
export const AuthContext = createContext(null);
